export default "__VITE_ASSET__CSzQJv0t__"